import { render } from "./AddEvent.vue?vue&type=template&id=7687e2f2&scoped=true"
import script from "./AddEvent.vue?vue&type=script&lang=js"
export * from "./AddEvent.vue?vue&type=script&lang=js"

import "./AddEvent.vue?vue&type=style&index=0&id=7687e2f2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7687e2f2"]])

export default __exports__